// Centralized API configuration
// Use this constant throughout the app instead of hardcoding URLs

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const API_BASE_URL = 'https://backend-977839565493.europe-west2.run.app';


